(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  const gallery = root.querySelector('[data-product-gallery]');
  const mainImage = gallery?.querySelector('.product__image');
  const thumbnailNavigation = gallery?.querySelector('[data-thumbnail-navigation]');
  const thumbnailTrack = gallery?.querySelector('[data-thumbnail-track]');
  const thumbnailPrevious = gallery?.querySelector('[data-thumbnail-previous]');
  const thumbnailNext = gallery?.querySelector('[data-thumbnail-next]');

  const updateThumbnailNavigation = () => {
    if (!thumbnailNavigation || !thumbnailTrack || !thumbnailPrevious || !thumbnailNext) return;

    const maximumScroll = Math.max(0, thumbnailTrack.scrollWidth - thumbnailTrack.clientWidth);
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const isOverflowing = isDesktop && maximumScroll > 2;

    thumbnailNavigation.classList.toggle('is-overflowing', isOverflowing);
    thumbnailPrevious.disabled = !isOverflowing || thumbnailTrack.scrollLeft <= 2;
    thumbnailNext.disabled = !isOverflowing || thumbnailTrack.scrollLeft >= maximumScroll - 2;
  };

  const scrollThumbnails = (direction) => {
    if (!thumbnailTrack) return;

    thumbnailTrack.scrollBy({
      left: direction * Math.max(240, thumbnailTrack.clientWidth * 0.75),
      behavior: 'smooth',
    });
  };

  thumbnailPrevious?.addEventListener('click', () => scrollThumbnails(-1));
  thumbnailNext?.addEventListener('click', () => scrollThumbnails(1));
  thumbnailTrack?.addEventListener('scroll', updateThumbnailNavigation, { passive: true });
  window.addEventListener('resize', updateThumbnailNavigation, { passive: true });
  window.requestAnimationFrame(updateThumbnailNavigation);

  const hydrateThumbnails = () => {
    gallery?.querySelectorAll('[data-thumbnail-src]').forEach((image) => {
      image.srcset = image.dataset.thumbnailSrcset || '';
      image.src = image.dataset.thumbnailSrc;
      image.removeAttribute('data-thumbnail-src');
      image.removeAttribute('data-thumbnail-srcset');
    });
  };

  const scheduleThumbnailHydration = () => {
    hydrateThumbnails();
    window.requestAnimationFrame(updateThumbnailNavigation);
  };

  if (mainImage?.complete && mainImage.naturalWidth) {
    scheduleThumbnailHydration();
  } else {
    mainImage?.addEventListener('load', scheduleThumbnailHydration, { once: true });
  }

  const showThumbnail = (thumbnail) => {
    if (!thumbnail || !mainImage) return;

    mainImage.src = thumbnail.dataset.src || mainImage.src;
    mainImage.srcset = thumbnail.dataset.srcset || '';
    mainImage.alt = thumbnail.dataset.alt || '';

    gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      const isActive = item === thumbnail;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', String(isActive));
    });
  };

  gallery?.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-gallery-thumb]');
    if (thumbnail) showThumbnail(thumbnail);
  });

  const select = root.querySelector('[data-variant-select]');
  if (!select) return;

  const price = root.querySelector('[data-product-price]');
  const comparePrice = root.querySelector('[data-product-compare-price]');
  const submit = root.querySelector('[data-add-to-cart]');
  const status = root.querySelector('[data-product-status]');

  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (!option) return;

    const available = option.dataset.available === 'true';
    const optionPrice = option.dataset.price || '';
    const optionComparePrice = option.dataset.comparePrice || '';

    if (price) price.textContent = optionPrice;
    if (comparePrice) {
      comparePrice.textContent = optionComparePrice;
      comparePrice.hidden = !optionComparePrice || optionComparePrice === optionPrice;
    }
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (status) {
      status.textContent = available
        ? 'In stock and ready to add to cart.'
        : 'This option is currently unavailable.';
    }

    if (option.dataset.imageId) {
      showThumbnail(gallery?.querySelector(`[data-image-id="${option.dataset.imageId}"]`));
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
})();
